import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { User } from '../manage-access.model';

import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';

@Component({
  selector: 'cigna-dialog-user-reset-password',
  templateUrl: './dialog-user-reset-password.component.html',
  styleUrls: ['./dialog-user-reset-password.component.scss'],
})
export class DialogUserResetPasswordComponent {
  impersonator$ = this.authFacade.isImpersonator$;
  resetPasswordView$ = this.manageAccessFacade.resetPasswordView$;
  resetPasswordResponse$ = this.manageAccessFacade.resetPasswordResponse$;

  constructor(
    public dialogRef: MatDialogRef<DialogUserResetPasswordComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      user: User;
    },
    private manageAccessFacade: ManageUserAccessFacade,
    private authFacade: AuthFacade,
  ) {}

  onReset(): void {
    this.manageAccessFacade.resetUserPassword(this.data.user.id);
  }
  onClose(): void {
    this.manageAccessFacade.resetUserPasswordView();
    this.dialogRef.close();
  }
}
